module.exports = __webpack_public_path__ + "img/member_bg.3ecb26d9.png";